import { Database } from "../schema.js";
//#region src/constants/sql/database.ts
var DatabaseVendor = {
	Databricks: "Databricks",
	MariaDB: "MariaDB",
	MSSQL: "MSSQL",
	MySQL: "MySQL",
	Oracle: "Oracle",
	PostgreSQL: "PostgreSQL",
	Snowflake: "Snowflake",
	SQLite: "SQLite"
};
var DatabaseVendorList = Object.values(DatabaseVendor);
var DatabaseVendorToDatabase = {
	[DatabaseVendor.Databricks]: Database.Databricks,
	[DatabaseVendor.MariaDB]: Database.MariaDB,
	[DatabaseVendor.MSSQL]: Database.MSSQL,
	[DatabaseVendor.MySQL]: Database.MySQL,
	[DatabaseVendor.Oracle]: Database.Oracle,
	[DatabaseVendor.PostgreSQL]: Database.PostgreSQL,
	[DatabaseVendor.Snowflake]: Database.Snowflake,
	[DatabaseVendor.SQLite]: Database.SQLite
};
//#endregion
export { DatabaseVendor, DatabaseVendorList, DatabaseVendorToDatabase };
